module.exports = __webpack_public_path__ + "static/img/4.75ed00c4.jpg";